// project import
import Default from "./default";

// ==============================|| PRESET THEME - THEME SELECTOR ||============================== //

const Theme = (colors, presetColor, mode) => {
	switch (presetColor) {
		case 'default':
			return Default(colors, mode);
		default:
			return Default(colors);
	}
};

export default Theme;
